/**
 * Dependências externas
 */
import React from 'react';
import { connect as connectToFormik } from 'formik';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  RadioGroup,
  Radio
} from '@chakra-ui/core';

/**
 * Dependências internas
 */
import getInformacoesDoCampo from '../../../../../utils/form/getInformacoesDoCampo';

const TipoDeRateio = props => {
  const nomeDoCampo = 'tipoRateio';

  const { formik, ...rest } = props;

  const { handleChange, handleBlur } = formik;

  const { valor, erro, possuiErroDeValidacao } = getInformacoesDoCampo(
    props,
    nomeDoCampo
  );

  return (
    <FormControl isInvalid={possuiErroDeValidacao} {...rest}>
      <FormLabel htmlFor={nomeDoCampo}>Tipo de rateio</FormLabel>
      <RadioGroup
        isInline
        spacing={4}
        value={valor}
        onChange={handleChange}
        onBlur={handleBlur}
        name={nomeDoCampo}
      >
        <Radio value="UNIDADE" size="md" isDisabled={rest.isDisabled}>
          Unidade
        </Radio>
        <Radio value="FRACAO_IDEAL" isDisabled={rest.isDisabled}>
          Fração ideal
        </Radio>
      </RadioGroup>
      {possuiErroDeValidacao && <FormErrorMessage>{erro}</FormErrorMessage>}
    </FormControl>
  );
};

export default connectToFormik(TipoDeRateio);
